// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".playlist-addtomenu{right:0;width:143px}.playlist-addtomenu__item:hover{color:#fff}", ""]);
// Exports
module.exports = exports;
